import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';
import { IWidgetApplicationContext } from '../../../types/widgetContext';
import { IReduxStore } from '../../../types/redux';
import { WidgetContext } from '../../../utils/widgetContext';
import { WidgetWrapperContainer } from '../WidgetWrapper';

interface IProps {
  context: IWidgetApplicationContext;
  store: IReduxStore;
}

export const ApplicationContainer = (props: IProps) => {
  const { store, context } = props;
  const { logger } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <WidgetContext.Provider value={context}>
        <UiKitContextProvider>
          <Provider store={store}>
            <WidgetWrapperContainer />
          </Provider>
        </UiKitContextProvider>
      </WidgetContext.Provider>
    </ErrorLogComponent>
  );
};
